import React, { useState } from 'react';
import { Server, Tag, Filter, BrainCircuit, PenLine, Users } from 'lucide-react';
import { useApp } from '@/context/AppContext';
import { AccountTab } from './settings/AccountTab';
import { CategorieTab } from './settings/CategorieTab';
import { RegoleTab } from './settings/RegoleTab';
import { AITab } from './settings/AITab';
import { SignatureTab } from './settings/SignatureTab';
import { UtentiTab } from './settings/UtentiTab';

const ALL_TABS = [
  { id: 'account',   label: 'Account',   icon: Server,        adminOnly: true },
  { id: 'utenti',    label: 'Utenti',    icon: Users,         adminOnly: true },
  { id: 'categorie', label: 'Categorie', icon: Tag,           adminOnly: false },
  { id: 'regole',    label: 'Regole',    icon: Filter,        adminOnly: false },
  { id: 'firme',     label: 'Firme',     icon: PenLine,       adminOnly: false },
  { id: 'ai',        label: 'AI',        icon: BrainCircuit,  adminOnly: true },
];

export default function Settings() {
  const { isAdmin } = useApp();
  const tabs = ALL_TABS.filter(t => isAdmin || !t.adminOnly);
  const defaultTab = tabs[0]?.id || 'categorie';
  const [activeTab, setActiveTab] = useState(defaultTab);

  return (
    <div className="flex-1 overflow-y-auto p-6">
      <div className="max-w-2xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-serif mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>Impostazioni</h1>
          <p className="text-sm text-gray-400">
            {isAdmin
              ? 'Gestisci account, utenti, categorie e regole di smistamento'
              : 'Gestisci categorie, regole e firme personali'}
          </p>
        </div>

        <div className="flex gap-1 mb-6 p-1 rounded-xl flex-wrap" style={{ background: '#EDE8E0' }}>
          {tabs.map(tab => {
            const Icon = tab.icon;
            const active = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                data-testid={`settings-tab-${tab.id}`}
                onClick={() => setActiveTab(tab.id)}
                className="flex-1 min-w-0 flex items-center justify-center gap-2 py-2.5 px-3 text-sm font-medium rounded-lg transition-all"
                style={{
                  background: active ? 'white' : 'transparent',
                  color: active ? '#333' : '#7F8C8D',
                  boxShadow: active ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                }}
              >
                <Icon size={14} />
                {tab.label}
              </button>
            );
          })}
        </div>

        {activeTab === 'account'   && isAdmin && <AccountTab />}
        {activeTab === 'utenti'    && isAdmin && <UtentiTab />}
        {activeTab === 'categorie' && <CategorieTab />}
        {activeTab === 'regole'    && <RegoleTab />}
        {activeTab === 'firme'     && <SignatureTab />}
        {activeTab === 'ai'        && isAdmin && <AITab />}
      </div>
    </div>
  );
}
